import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import InvoicewiseSalesReportView from './InvoicewiseSalesReportView'
import InvoicewiseSalesReportFromInvoiceView from './InvoicewiseSalesReportFromInvoiceView'

const InvoicewiseSalesReport = () => {
    const dataMode = localStorage.getItem("dataMode");
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Invoicewise Report" mainTitle="Invoicewise Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {dataMode === "invoicewise" ? <InvoicewiseSalesReportFromInvoiceView /> : <InvoicewiseSalesReportView />}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default InvoicewiseSalesReport
